var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgArrowTrendingDown(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.68908 13.8747L2.02365 13.8743L1.9485 13.8639L1.8744 13.8432L1.82918 13.824C1.76978 13.7978 1.71405 13.7599 1.66515 13.7109L1.63463 13.6779L1.602 13.6356L1.56135 13.568L1.53233 13.5003L1.518 13.4522L1.5078 13.4042L1.50075 13.3336L1.50038 7.68425C1.50038 7.3736 1.75223 7.12176 2.06288 7.12176C2.34765 7.12176 2.583 7.33337 2.62028 7.6079L2.62538 7.68425L2.62575 11.9554L8.41485 6.16523C8.61458 5.96552 8.92703 5.94737 9.1473 6.11075L9.21038 6.16522L11.4382 8.393L15.5405 4.29073C15.7602 4.07106 16.1163 4.07106 16.336 4.29073C16.5357 4.49043 16.5538 4.80292 16.3904 5.02313L16.336 5.08622L11.836 9.58625C11.6363 9.7859 11.3238 9.80405 11.1036 9.6407L11.0405 9.58625L8.81265 7.35847L3.42225 12.7497L7.68908 12.7497C7.97385 12.7497 8.20913 12.9613 8.2464 13.2358L8.25158 13.3122C8.25158 13.597 8.03993 13.8323 7.76535 13.8696L7.68908 13.8747Z",
    fill: "#F11E84"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrowTrendingDown);
export default __webpack_public_path__ + "static/media/arrow-trending-down.d555c400b7a9e5af897c657db08daa99.svg";
export { ForwardRef as ReactComponent };